import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
const Home = lazy(() => import("./pages/Home"));
const TaxiVanParis = lazy(() => import("./pages/TaxiVanParis"));
const ReserverTaxi7 = lazy(() => import("./pages/ReserverTaxi7"));
const TaxiCdg = lazy(() => import("./pages/TaxiCdg"));
const TaxiOrly = lazy(() => import("./pages/TaxiOrly"));
const TaxiDisneyland = lazy(() => import("./pages/TaxiDisneyland"));
const TaxiGare = lazy(() => import("./pages/TaxiGare"));
const TaxiVersailles = lazy(() => import("./pages/TaxiVersailles"));
const ChauffeurPrive = lazy(() => import("./pages/ChauffeurPrive"));
const Tarifs = lazy(() => import("./pages/Tarifs"));
const NosVehicules = lazy(() => import("./pages/NosVehicules"));
const Services = lazy(() => import("./pages/Services"));
const Contact = lazy(() => import("./pages/Contact"));
const APropos = lazy(() => import("./pages/APropos"));
const Destinations = lazy(() => import("./pages/Destinations"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const NotFound = lazy(() => import("./pages/NotFound"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("./pages/PaymentCancel"));
const MentionsLegales = lazy(() => import("./pages/Legal").then(m => ({ default: m.MentionsLegales })));
const PolitiqueConfidentialite = lazy(() => import("./pages/Legal").then(m => ({ default: m.PolitiqueConfidentialite })));
const ConditionsGenerales = lazy(() => import("./pages/Legal").then(m => ({ default: m.ConditionsGenerales })));
import BookingWidget from "./components/BookingWidget";
import WhatsAppButton from "./components/WhatsAppButton";
import CookieConsent from "./components/CookieConsent";
import { LanguageProvider } from "./i18n/LanguageContext";
import { trackGoogleAdsConversion } from "./lib/googleAds";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  useEffect(() => {
    const handlePhoneClick = (event) => {
      const link = event.target.closest('a[href^="tel:"]');

      if (!link) return;
      if (link.closest(".cabcity-booking-widget")) return;

      trackGoogleAdsConversion({
        type: "phoneCall",
      });
    };

    document.addEventListener("click", handlePhoneClick);

    return () => {
      document.removeEventListener("click", handlePhoneClick);
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>

	<LanguageProvider>
        <ScrollManager />
        <BookingWidget />
        <WhatsAppButton />
        <CookieConsent />
        <div className="flex min-h-screen flex-col bg-white">
          <Header />
          <main id="contenu-principal" className="flex-1">
            <Suspense fallback={null}>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/reserver-taxi-7-places/" element={<ReserverTaxi7 />} />
              <Route path="/taxi-van-paris/" element={<TaxiVanParis />} />
              <Route path="/taxi-cdg/" element={<TaxiCdg />} />
              <Route path="/taxi-orly/" element={<TaxiOrly />} />
              <Route path="/taxi-disneyland-paris/" element={<TaxiDisneyland />} />
              <Route path="/taxi-gare-paris/" element={<TaxiGare />} />
              <Route path="/taxi-versailles/" element={<TaxiVersailles />} />
              <Route path="/chauffeur-prive-paris/" element={<ChauffeurPrive />} />
              <Route path="/tarifs/" element={<Tarifs />} />
              <Route path="/nos-vehicules/" element={<NosVehicules />} />
              <Route path="/services/" element={<Services />} />
              <Route path="/contact/" element={<Contact />} />
              <Route path="/a-propos/" element={<APropos />} />
              <Route path="/destinations/" element={<Destinations />} />
              <Route path="/blog/" element={<Blog />} />
              <Route path="/blog/:slug/" element={<BlogArticle />} />
              <Route path="/mentions-legales/" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite/" element={<PolitiqueConfidentialite />} />
              <Route path="/conditions-generales/" element={<ConditionsGenerales />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              {/* English routes */}
              <Route path="/en/" element={<Home />} />
              <Route path="/en/reserver-taxi-7-places/" element={<ReserverTaxi7 />} />
              <Route path="/en/taxi-van-paris/" element={<TaxiVanParis />} />
              <Route path="/en/taxi-cdg/" element={<TaxiCdg />} />
              <Route path="/en/taxi-orly/" element={<TaxiOrly />} />
              <Route path="/en/taxi-disneyland-paris/" element={<TaxiDisneyland />} />
              <Route path="/en/taxi-gare-paris/" element={<TaxiGare />} />
              <Route path="/en/taxi-versailles/" element={<TaxiVersailles />} />
              <Route path="/en/chauffeur-prive-paris/" element={<ChauffeurPrive />} />
              <Route path="/en/tarifs/" element={<Tarifs />} />
              <Route path="/en/nos-vehicules/" element={<NosVehicules />} />
              <Route path="/en/services/" element={<Services />} />
              <Route path="/en/contact/" element={<Contact />} />
              <Route path="/en/a-propos/" element={<APropos />} />
              <Route path="/en/destinations/" element={<Destinations />} />
              <Route path="/en/blog/" element={<Blog />} />
              <Route path="/en/blog/:slug/" element={<BlogArticle />} />
              <Route path="/en/mentions-legales/" element={<MentionsLegales />} />
	      <Route path="/en/politique-confidentialite/" element={<PolitiqueConfidentialite />} />
	      <Route path="/en/conditions-generales/" element={<ConditionsGenerales />} />
	      <Route path="*" element={<NotFound />} />
            </Routes>
              </Suspense>
          </main>
          <Footer />
        </div>
	</LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
